import { BaseController } from '../../../common/base/controller';

export class HistoryController extends BaseController {
  constructor(controllerService, historyService) {
    'ngInject';
    super({
      controllerService,
      historyService,
    });
  }

  get templateUrl() {
    switch (this.displayMode) {
      case 'event': {
        return this.historyService.historyEventNameTemplate;
      }
      case 'time': {
        return this.historyService.historyTimeTemplate;
      }
    }
    return null;
  }

  $onInit() {
    const { historyService } = this;

    this.displayMode = historyService.displayMode;
    this.displayModeOptions = historyService.displayModeOptions;

    this.dateFormat = historyService.dateFormat;
    this.timeFormat = historyService.timeFormat;
  }

  $onChanges(changeset) {
    const { historyService } = this;

    // Create a reversed copy list of the given events.
    // Enrich events with date and time value which is being used
    // to group the events and ignore outfiltered events that equal null.
    this.eventList = this.events
      .slice()
      .reverse()
      .filter((event) => historyService.updateEvent(event) !== null);
  }

  getEventIcon(event) {
    return this.historyService.getEventIcon(event);
  }

  onAction($event, event) {
    $event.stopPropagation();
    this.action(event);
  }
}
